import "swiper/swiper.min.css";
import modalStyle from "../../styles/modal.module.scss";
import singleStyle from "../../styles/single.module.scss";
import CollectionButton from "../CollectionButton";
import { Swiper, SwiperSlide } from "swiper/react";

export default function MobileMaterialModal({
  handleCloseModal,
  materialData,
  vendor,
  title,
  handleImageLoaded,
  imageLoaded,
  description,
  handleChangeImage,
  ROOT_SERVER,
  slug,
  loaded,
}) {
  return (
    <div className={modalStyle.modalShade} onClick={handleCloseModal}>
      {loaded ? (
        <div
          className={modalStyle.materialModal}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxHeight: "95vh",
            maxWidth: "98vw",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#272b2bf8",
            borderRadius: "3px",
          }}
        >
          <div className={modalStyle.modalContent}></div>
          <div style={{ height: "300px", width: "400px" }}>
            {/* IMAGE CONTAINER START */}
            <div
              className={modalStyle.imageContainer}
              style={{ position: "relative", minHeight: "300px" }}
            >
              <div
                style={{
                  position: "absolute",
                  left: "10px",
                  top: 5,
                  zIndex: 5,
                  fontFamily: "Montserrat-Bold",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  color: "#FEFEFE",
                  filter: "drop-shadow(0px 0px 1px black)",
                }}
              >
                {vendor}
              </div>
              <div
                style={{
                  position: "absolute",
                  right: 40,
                  top: 5,
                  zIndex: 2,
                  color: "#FEFEFE",
                  filter: "drop-shadow(0px 0px 1px black)",
                }}
              >
                <CollectionButton materialId={materialData.id} />
              </div>
              {!imageLoaded && <div className="spinner" />}
              <Swiper
                pagination={true}
                navigation={true}
                //ref={swiperRef}
                onSlideChange={(swiper) => {
                  handleChangeImage(swiper.activeIndex);
                }}
                //onSwiper={() => console.log("swipper working")}
              >
                {materialData.images.length >= 1
                  ? materialData.images.map((item, i) => (
                      <SwiperSlide key={i}>
                        <img
                          alt={item}
                          className={singleStyle.materialImage}
                          //src={`${ROOT_SERVER}${vendor}/${slug}/full/${item}`}
                          src={`${ROOT_SERVER}${vendor}/${slug}/swatch/${item}`}
                          loading="lazy"
                          onLoad={handleImageLoaded}
                          // style={
                          //   imageLoaded
                          //     ? { filter: "blur(0px)" }
                          //     : { filter: "blur(6px)" }
                          // }
                        />
                      </SwiperSlide>
                    ))
                  : false}
              </Swiper>
              <div className={modalStyle.imageSelector}></div>
            </div>
            {/* IMAGE CONTAINER END */}
          </div>
          <div
            style={{
              height: "calc(100vh - 300px)",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "2px 10px",
              color: "#FEFEFE",
            }}
          >
            <h4 style={{ textTransform: "uppercase", color: "#00ffed" }}>
              {title}
            </h4>
            <h6>{description}</h6>
          </div>
        </div>
      ) : (
        <div>Loading it up</div>
      )}
    </div>
  );
}
